export default __webpack_public_path__ + "static/assets/cea052dc75a4f68f1a4a675fcbd7b03f.png";